import { render, staticRenderFns } from "./NewAddLabelAction.vue?vue&type=template&id=dc44051a&scoped=true&"
import script from "./NewAddLabelAction.vue?vue&type=script&lang=js&"
export * from "./NewAddLabelAction.vue?vue&type=script&lang=js&"
import style1 from "./NewAddLabelAction.vue?vue&type=style&index=1&id=dc44051a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc44051a",
  null
  
)

export default component.exports